import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/item-logo-stavax.png")